import React from "react";
import { useSelector } from "react-redux";
import { Header3 } from "@activecollab/components";
import PropTypes from "prop-types";
import { getConfigOption } from "~/store/selectors/selector.configOptions";
import { getTaskById } from "~/store/selectors/selector.tasks";
import { ExpenseModalContainer } from "./ExpenseModalContainer";
import { ExpenseParentTotalContainer } from "./ExpenseParentTotalContainer";
import { ListGroupByDate } from "./ListGroupByDate";
import { Divider } from "../ModalObjects";

export const ExpenseListModal = ({ open, onClose, taskId, projectId }) => {
  const task = useSelector((state) => getTaskById(state, taskId));
  const showTaskNumber = useSelector((state) => getConfigOption(state, "show_task_id"));

  return (
    <ExpenseModalContainer
      open={open}
      onClose={onClose}
      parentId={taskId}
      parentType="Task"
      projectId={projectId}
    >
      <div className="tw-px-8 tw-py-6">
        <div className="tw-flex tw-justify-between">
          <Header3 className="tw-truncate tw-mr-4">
            {showTaskNumber ? `#${task.task_number}: ${task.name}` : task.name}
          </Header3>
          <ExpenseParentTotalContainer
            parentId={taskId}
            parentType="Task"
            projectId={projectId}
            hideExpandSingle
            className="tw-shrink-0"
          />
        </div>
        <Divider className="tw-my-6" />
        <ListGroupByDate
          parentId={taskId}
          parentType="Task"
          projectId={projectId}
        />
      </div>
    </ExpenseModalContainer>
  );
};

ExpenseListModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  taskId: PropTypes.number.isRequired,
  projectId: PropTypes.number.isRequired,
};

ExpenseListModal.defaultProps = {
  open: false,
};
